Vue.component('ack-cart-icon', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-cart-icon',
    created(){
      EventBus.$on('shop-cart-items-change', () => {
        this.onCartItemsChange()
      })
    },
    mounted() {
      appLog.log('ack-cart-icon mounted')



    },
    props:{
      data: {
        type: Object,
        required: false
      }

    },
    computed: {
        ...Vuex.mapGetters('shop', ['numberOfSelectedProducts', 'numberOfCartProducts', 'selectedProductList', 'cart']),

    },
    data() {
      return {
        quantity: 1,
        cartIcreaseItemsSwitch: false
      }
    },
    methods: {
      //...Vuex.mapActions(['sayHi', 'someAction']),
      //...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),
      openCart(){
        EventBus.$emit('show-cart')
      },
      onCartItemsChange(){
        this.cartIcreaseItemsSwitch = true
          setTimeout(()=>{
            this.cartIcreaseItemsSwitch = false
          }, 500)

        this.openCart()
      }


    },
    beforeDestroy() {

    },
    watch: {

      numberOfCartProducts: {
        handler() {

          this.onCartItemsChange()

        },
        deep: false
      }
    }
  })